import React from 'react';

import NewCoursePage from './NewCoursePage';

const NewSafety = props => (
  <NewCoursePage {...props} videoLink="F2Aeek1sKuo" header={'Trip Safety'}>
    <h4>Trip Scenarios</h4>
    <ol className="new-course__body__content__olist">
      <li>
        Rider is using a power scooter and not a wheelchair.
        <ul className="new-course__body__content__olist--ulist">
          <li>
            If the scooter can face forward and be secured at 4 points, the
            rider can remain in the scooter. If not, the rider can move to
            a regular seat if the scooter can be safely stored. Some
            scooters can fold completely and fit in to the trunk. For those
            that don’t fold, the scooter can remain in the cabin if both
            the rider and driver deem it is safe.
          </li>
        </ul>
      </li>
      <li>
        Rider does not want to have their chair and/or themselves secured.
        <ul className="new-course__body__content__olist--ulist">
          <li>
            Drivers should not take riders unless they are willing to be
            secured. If riders are not willing to have both themselves and
            their assistive device secured, drivers should cancel the trip
            and submit a claim to receive a reward for the canceled trip.
          </li>
        </ul>
      </li>
      <li>
        Rider is not using wheelchair.
        <ul className="new-course__body__content__olist--ulist">
          <li>
            If a rider is not using a wheelchair they should not be using
            this service as reduces the supply of vehicle to those who need
            them. If a rider is not using a wheelchair but has a service
            animal they should be booking an UberASSIST. You may inform
            them of this for future occasions.
          </li>
        </ul>
      </li>
    </ol>

    <hr />
    <h4>Trip Best Practice</h4>

    <ol className="new-course__body__content__olist">
      <li>
        Find a safe, accessible place to park.
        <ul className="new-course__body__content__olist--ulist">
          <li>
            You should get out of your vehicle and introduce yourself.
          </li>
        </ul>
      </li>
      <li>
        Ask your passenger how/if they would like to be assisted.
        <ul className="new-course__body__content__olist--ulist">
          <li>
            You should not touch a passenger or their wheelchair without
            permission. They may have a support person, but you should
            still talk to them directly.
          </li>
        </ul>
      </li>
      <li>
        Help stroll the wheelchair up the ramp if required.
        <ul className="new-course__body__content__olist--ulist">
          <li>
            The wheelchair should be facing towards the car when going up
            the ramp for safety.
          </li>
        </ul>
      </li>
      <li>
        Secure the wheelchair and passenger.
        <ul className="new-course__body__content__olist--ulist">
          <li>
            Ensure the wheelchair breaks are on and are strapped down with
            4 points and the belt is attached. The wheelchair should face
            forward and be tightly secured.
          </li>
        </ul>
      </li>
      <li>
        Allow any service animals/medical equipment on.
        <ul className="new-course__body__content__olist--ulist">
          <li>
            Service animals should be allowed on and not be interacted
            with. Any equipment should be secured and not moving around.
          </li>
        </ul>
      </li>
      <li>
        Engage in conversation.
        <ul className="new-course__body__content__olist--ulist">
          <li>If appropriate, you can engage in relevant conversation.</li>
        </ul>
      </li>
      <li>
        Safely unsecure the passenger.
        <ul className="new-course__body__content__olist--ulist">
          <li>
            Upon drop-off, the vehicle should be parked in a safe
            accessible place that is away from traffic and barriers. The
            wheelchair should be unsecured in reverse order. Start with the
            shoulder and lap belt, then remove the 4 J Hooks and the 4
            retractors if they get in the way of removing the wheelchair.
            Unlock the door and unfold the ramp.
          </li>
        </ul>
      </li>
      <li>
        Safely descend down the ramp.
        <ul className="new-course__body__content__olist--ulist">
          <li>
            Unlock the wheel breaks on the wheelchair and descend down the
            ramp slowly. It is best to be facing the vehicle, not the ramp
            and to descend down the ramp backwards as the wheelchair is
            more supported than when facing forward.
          </li>
        </ul>
      </li>
      <li>
        Offer assistance to the curb and ask if there is any other help you
        can provide before leaving.
      </li>
    </ol>

    <hr />
    <h4>Emergency Procedures</h4>

    <ol className="new-course__body__content__olist">
      <li>
        Perform a Health Check
        <ul className="new-course__body__content__olist--ulist">
          <li>
            Check yourself and passengers for any injuries. Call 911 if
            necessary.
          </li>
        </ul>
      </li>
      <li>
        Contact our 24/7 Emergency Team
        <ul className="new-course__body__content__olist--ulist">
          <li>
            Call 1-833-MYAUTZU ext. 4001 and let us know you was involved
            in an accident. Our 24/7 Support Team will be able to give you
            all the instructions you need to assist you in the event of an
            accident.
          </li>
        </ul>
      </li>
      <li>
        Exchange Information{' '}
        <p style={{ margin: '1em 0' }}>
          Obtain the following information from the other driver involved
          in the accident:
        </p>
        {/* <ul className="course-page_ulist"> */}
        <ul className="new-course__body__content__olist--ulist">
          <li>Full name and contact information</li>
          <li>Insurance company and policy number</li>
          <li>Driver's licence and licence plate number</li>
          <li>Type, colour and model of vehicle</li>
          <li>Time of the accident</li>
          <li>Location of incident</li>
        </ul>
      </li>
      <li>
        Document the Incident
        <p style={{ margin: '1em 0' }}>
          In order to protect yourself and assist the insurance claim:
        </p>
        <ul className="new-course__body__content__olist--ulist">
          <li>Get a copy of the accident report from authorities</li>
          <li>Take pictures of the damage to both vehicles</li>
        </ul>
      </li>
      <li>
        Notify Authorities / Report Damage
        <p style={{ margin: '1em 0' }}>
          Even if it is a minor incident, you must report the vehicle
          damage immediately to a Collision Reporting Centre. If the
          vehicle is still driveable, you should head to either of the two
          centres in the GTA:
        </p>
        <ul className="new-course__body__content__olist--ulist">
          <li style={{ 'padding-bottom': 0 }}>
            <a
              style={{ color: '#128DFF', 'font-weight': 'bold' }}
              href="https://www.google.ca/maps/place/113+Toryork+Dr,+North+York,+ON+M9L+1X9/@43.7563839,-79.5537062,17z/data=!3m1!4b1!4m5!3m4!1s0x882b300e5c17f3a1:0xf4ff066b6c84a4f!8m2!3d43.7563839!4d-79.5515175"
              target="_blank"
              className="course-page_link"
              rel="noopener noreferrer">
              NORTH COLLISION REPORTING CENTRE
            </a>
            <p
              className="new-course__body__content__para"
              style={{ margin: '1em 0' }}>
              113 York Drive, North York (416) 808-2222
            </p>
            <p className="new-course__body__content__para">
              Hours of operation: Open 7 days a week all year, 6:00 a.m. to
              Midnight.
            </p>
          </li>
          <li>
            <a
              style={{ color: '#128DFF', 'font-weight': 'bold' }}
              href="https://www.google.ca/maps/place/39+Howden+Rd,+Scarborough,+ON+M1R+3C7/data=!4m2!3m1!1s0x89d4d1f8caee814d:0x813844784d76eabb?sa=X&amp;ved=0ahUKEwiv6MvJ5szSAhUP42MKHYcWBVkQ8gEIIjAB"
              target="_blank"
              className="course-page_link"
              rel="noopener noreferrer">
              EAST COLLISION REPORTING CENTRE
            </a>
            <p
              className="new-course__body__content__para"
              style={{ margin: '1em 0' }}>
              39 Howden Road, Scarborough (416) 808-2222
            </p>
            <p className="new-course__body__content__para">
              Hours of operation: Open 7 days a week all year, 6:00 a.m. to
              Midnight.
            </p>
          </li>
        </ul>
      </li>
    </ol>
    <br />
    <br />
  </NewCoursePage>
);

export default NewSafety;



// WEBPACK FOOTER //
// ./src/components/NewCourse/NewSafety.js